import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import { AppRoutes } from './app/routing/AppRoutes'
import { ToastContainer } from 'react-toastify'
import './app/styles/fonts.css'
import './app/styles/main.css'
import './app/styles/kendo.css';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <ToastContainer />
      <AppRoutes />
    </QueryClientProvider>
  )
}
